export default "/images/998b75764bb0ccd9c93c1a33ec233e53.avif";